import { nanoid } from 'nanoid';
import { useCallback, useState } from 'react';
import { ApiError } from 'shared/api';

import { fetchLocationsAutocomplete } from '../api';

export function useLocationAutocompleteSearchOptions() {
    const [ sessionToken, setSessionToken ] = useState(nanoid);

    const searchOptions = useCallback(async (searchString = '', signal?: AbortSignal) => {
        if (!searchString || searchString.length < 3) {
            return [];
        }

        const response = await fetchLocationsAutocomplete(searchString, sessionToken, signal);

        if (response instanceof ApiError) {
            return response;
        }

        return response.map(prediction => ({
            text: prediction.description,
            placeId: prediction.placeId,
            structuredFormatting: prediction.structuredFormatting
        }));
    }, [ sessionToken ]);

    const endSession = useCallback(() => {
        setSessionToken(nanoid());
    }, []);

    return {
        searchOptions,
        endSession
    };
}
